import { Box, Text, Popover, PopoverTrigger, PopoverContent, DataList, DataItem, cssVar } from '@cad-arc';
import { RelatedDataEntity } from '@mark43/cad-api';
import { DATA_ITEM_LINE_HEIGHT } from '../constants';

export const AdditionalDispositionsPopover = ({ cadEvent }: { cadEvent: RelatedDataEntity }) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Text
                    data-testid="ADDITIONAL_DISPOSITION_POPOVER_TRIGGER"
                    as="span"
                    variant="bodyMd"
                    style={{
                        color: cssVar('arc.colors.brand.default'),
                        cursor: 'pointer',
                        margin: '0',
                        lineHeight: DATA_ITEM_LINE_HEIGHT,
                    }}
                >
                    +{cadEvent.additionalDispositionsCount}
                </Text>
            </PopoverTrigger>
            <PopoverContent>
                <Text variant="headingXs">Dispositions</Text>
                <Box
                    fontSize="sm"
                    marginTop="2"
                    data-testid="ADDITIONAL_DISPOSITION_POPOVER_CONTENT"
                >
                    <DataList variant="inline" spacing="1">
                        <DataItem dataKey="Primary">{cadEvent.disposition}</DataItem>
                        {cadEvent.additionalDispositions.map((additionalDisposition, index) => {
                            return (
                                <DataItem key={index} dataKey="Additional">
                                    {additionalDisposition}
                                </DataItem>
                            );
                        })}
                    </DataList>
                </Box>
            </PopoverContent>
        </Popover>
    );
};
